import uuidv4 from 'uuid/v4';

/** Stable ids for scenes and pids — both anchor server-side comments and the
 * Grafter sync, so they share one generator (the app's existing uuid dep). */
export function newStableId() {
  return uuidv4();
}
